const t = {
  name: "TravelBag",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 2H8V6H5C3.34772 6 2 7.34772 2 9V19C2 20.6523 3.34772 22 5 22H19C20.6523 22 22 20.6523 22 19V9C22 7.34772 20.6523 6 19 6H16V2ZM8 20V8H16V20H8ZM6 8V20H5C4.45228 20 4 19.5477 4 19V9C4 8.45228 4.45228 8 5 8H6ZM19 20H18V8H19C19.5477 8 20 8.45228 20 9V19C20 19.5477 19.5477 20 19 20ZM14 6H10V4H14V6Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as TravelBag
};
